import * as React from 'react';

import { AsyncVisitSidePanel } from '../../components/core/AsyncVisitSidePanel';
import { DocumentTitle } from '../../components/core/DocumentTitle';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setVisitCode } from '../../redux/ui/actions';

export function Visit() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { zendeskTicketId, code } = useParams<{ code: string; zendeskTicketId: string }>();
  const showReferralPanel = location.pathname.indexOf('referral') > -1;

  useEffect(() => {
    dispatch(setVisitCode(code!));
  }, [code, dispatch]);

  return (
    <>
      <DocumentTitle title={`${code} Visit`} />
      <AsyncVisitSidePanel visitCode={code!} showReferralPanel={showReferralPanel} zendeskTicketId={zendeskTicketId} hideCloseIcon />
    </>
  );
}
